import { NUMBER_REGEX } from 'constants/regexp';

const parseNumber = (string) => (string.replace(',', '.').match(NUMBER_REGEX) || []).join('');

export default parseNumber;
